import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import NotificationBell from "./NotificationBell";
export default function Header() {
  const { currentUser, logout, getMySales, favorites } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => { logout(); navigate("/login"); setMenuOpen(false); };
  const isActive = (path) => location.pathname === path;
  const newSales = currentUser ? (getMySales?.() || []).filter(s => s.status === "pending").length : 0;
  const close = () => setMenuOpen(false);
  const isAdvertiser = currentUser?.role === "advertiser";

  return (
    <>
      <header style={styles.header}>
        <div style={styles.inner}>
          {/* Logo */}
          <Link to="/" style={styles.logo} onClick={close}>
            <img src="/icon-192.png" alt="Yad2Yad" style={styles.logoIcon} />
            <div style={styles.logoStack}>
              <div style={styles.logoMain}>
                <span style={styles.logoHe}>יד לָיָד</span>
                <span style={styles.logoDivider}>✦</span>
                <span style={styles.logoLat}>Yad<span style={{color:"#1D9E75"}}>2</span>Yad</span>
              </div>
              <div style={styles.logoSub}>קהילה יהודית • Comunidad Judia</div>
            </div>
          </Link>

          {/* Desktop nav — oculto en mobile */}
          {!isMobile && (
            <nav style={styles.desktopNav}>
              <Link to="/"             style={{...styles.link,...(isActive("/")            ?styles.linkActive:{})}}>🏠 Inicio</Link>
              {(!currentUser || isAdvertiser) && (
                <Link to="/catalog"      style={{...styles.link,...(isActive("/catalog")     ?styles.linkActive:{})}}>🛍️ Catalogo</Link>
              )}
              <Link to="/favorites"    style={{...styles.link,...(isActive("/favorites")   ?styles.linkActive:{})}}>
                ❤️ Favoritos {favorites?.length>0&&<span style={styles.navBadge}>{favorites.length}</span>}
              </Link>
              <Link to="/advertise"     style={{...styles.link,...(isActive("/advertise")   ?styles.linkActive:{})}}>📢Publicidad</Link>
              {currentUser && !isAdvertiser && (
                <>
                  <Link to="/my-posts"     style={{...styles.link,...(isActive("/my-posts")    ?styles.linkActive:{})}}>📦 Mis publicaciones</Link>
                  <Link to="/my-sales"     style={{...styles.link,...(isActive("/my-sales")    ?styles.linkActive:{})}}>
                    🏷️ Mis ventas {newSales>0&&<span style={styles.navBadge}>{newSales}</span>}
                  </Link>
                  <Link to="/my-purchases" style={{...styles.link,...(isActive("/my-purchases")?styles.linkActive:{})}}>🛒 Mis compras</Link>
                </>
              )}
              {isAdvertiser && (
                <Link to="/my-ad" style={{...styles.link,...(isActive("/my-ad")?styles.linkActive:{})}}>📋 Mi publicidad</Link>
              )}
              <Link to="/terms"       style={{...styles.link,...(isActive("/terms")      ?styles.linkActive:{})}}>📋 Términos y condiciones</Link>

              {currentUser?.role==="admin"&&<Link to="/admin" style={{...styles.link,...(isActive("/admin")?styles.linkActive:{})}}>⚙️ Admin</Link>}
            </nav>
          )}

          {/* Acciones derecha */}
          <div style={styles.rightArea}>
            {currentUser ? (
              <>
                <NotificationBell />

                {/* Publicar — solo desktop, no para anunciantes */}
                {!isMobile && !isAdvertiser && (
                  <Link to="/new-product" style={styles.btnPublish} onClick={close}>+ Publicar</Link>
                )}

                {/* Avatar desktop */}
                {!isMobile && (
                  <div style={styles.avatarDesktop}>
  {!isAdvertiser && (
    <Link to="/profile" style={{...styles.avatar, textDecoration:"none"}} onClick={close}>
      {currentUser.name.charAt(0).toUpperCase()}
    </Link>
  )}
  <button onClick={handleLogout} style={styles.btnLogout}>Salir</button>
</div>
                )}

                {/* Hamburguesa — solo mobile */}
                {isMobile && (
                  <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? "✕" : "☰"}
                  </button>
                )}
              </>
            ) : (
              <>
                {isMobile && (
                  <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? "✕" : "☰"}
                  </button>
                )}
                <Link to="/login"    style={styles.btnLogout}>Ingresar</Link>
                <Link to="/register" style={styles.btnPublish}>Registrarse</Link>
              </>
            )}
          </div>
        </div>
      </header>

      {/* Menu mobile overlay */}
      {menuOpen && isMobile && (
        <div style={styles.mobileOverlay} onClick={close}>
          <div style={styles.mobileMenu} onClick={e => e.stopPropagation()}>
            {currentUser && (
              <div style={styles.mobileUser}>
                {!isAdvertiser ? (
                  <Link to="/profile" style={{...styles.mobileAvatar, textDecoration:"none"}} onClick={close}>
                    {currentUser.name.charAt(0).toUpperCase()}
                  </Link>
                ) : (
                  <div style={styles.mobileAvatar}>{currentUser.name.charAt(0).toUpperCase()}</div>
                )}
                <div>
                  <p style={styles.mobileUserName}>{currentUser.name}</p>
                  <p style={styles.mobileUserEmail}>{currentUser.email}</p>
                </div>
              </div>
            )}

            {[
              {to:"/",            label:"🏠 Inicio"},
              ...(!currentUser || isAdvertiser ? [{to:"/catalog", label:"🛍️ Catalogo"}] : []),
              {to:"/favorites",   label:`❤️ Favoritos${favorites?.length>0?` (${favorites.length})`:""}`},
              {to:"/advertise", label:"📢 Publicitate"},
              ...(currentUser && !isAdvertiser ? [
                {to:"/my-posts",    label:"📦 Mis publicaciones"},
                {to:"/my-sales",    label:`🏷️ Mis ventas${newSales>0?` (${newSales})`:""}`},
                {to:"/my-purchases",label:"🛒 Mis compras"},
                {to:"/profile",     label:"👤 Mi perfil"},
              ] : []),
              ...(isAdvertiser ? [{to:"/my-ad", label:"📋 Mi publicidad"}] : []),
              {to:"/terms",       label:"📋 Términos y condiciones"},
              ...(currentUser?.role==="admin"?[{to:"/admin",label:"⚙️ Panel admin"}]:[]),
            ].map(item => (
              <Link key={item.to} to={item.to}
                style={{...styles.mobileLink,...(isActive(item.to)?styles.mobileLinkActive:{})}}
                onClick={close}
              >
                {item.label}
              </Link>
            ))}

            {currentUser && !isAdvertiser && (
              <Link to="/new-product" style={styles.mobileBtnPublish} onClick={close}>
                + Publicar producto
              </Link>
            )}

            {currentUser ? (
              <button style={styles.mobileBtnLogout} onClick={handleLogout}>
                Cerrar sesion
              </button>
            ) : (
              <>
                <Link to="/login" style={styles.mobileBtnPublish} onClick={close}>Ingresar</Link>
                <Link to="/register" style={styles.mobileLink} onClick={close}>Registrarse</Link>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  header:{background:"#fff",borderBottom:"0.5px solid #e0e0e0",position:"sticky",top:0,zIndex:100,boxShadow:"0 1px 8px rgba(0,0,0,0.06)"},
  inner:{maxWidth:1300,margin:"0 auto",padding:"0 16px",height:60,display:"flex",alignItems:"center",gap:12},
  logo:{textDecoration:"none",color:"#111",flexShrink:0,display:"flex",alignItems:"center",gap:8},
  logoIcon:{width:32,height:32,flexShrink:0},
  logoStack:{display:"flex",flexDirection:"column",gap:1},
  logoMain:{display:"flex",alignItems:"center",gap:6},
  logoHe:{fontSize:16,fontWeight:700,color:"#1D9E75",direction:"rtl",fontFamily:"serif"},
  logoDivider:{fontSize:9,color:"#ccc"},
  logoLat:{fontSize:16,fontWeight:700,color:"#111"},
  logoSub:{fontSize:9,color:"#999"},
  desktopNav:{display:"flex",gap:2,flex:1,overflow:"hidden"},
  link:{padding:"5px 8px",borderRadius:8,fontSize:12,color:"#555",textDecoration:"none",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:3},
  linkActive:{background:"#f0faf6",color:"#1D9E75",fontWeight:500},
  navBadge:{background:"#E24B4A",color:"#fff",borderRadius:20,padding:"1px 5px",fontSize:10,fontWeight:700},
  rightArea:{display:"flex",alignItems:"center",gap:8,marginLeft:"auto",flexShrink:0},
  btnPublish:{background:"#1D9E75",color:"#fff",border:"none",borderRadius:8,padding:"7px 12px",fontSize:13,fontWeight:500,cursor:"pointer",textDecoration:"none",whiteSpace:"nowrap"},
  btnLogout:{background:"transparent",color:"#555",border:"0.5px solid #ddd",borderRadius:8,padding:"6px 10px",fontSize:13,cursor:"pointer",textDecoration:"none"},
  bellWrap:{position:"relative",display:"flex",alignItems:"center",textDecoration:"none",padding:"4px 6px"},
  badge:{position:"absolute",top:0,right:0,background:"#E24B4A",color:"#fff",borderRadius:"50%",width:16,height:16,fontSize:10,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:600},
  hamburger:{background:"none",border:"none",fontSize:24,cursor:"pointer",padding:"4px 8px",color:"#333"},
  avatarDesktop:{display:"flex",alignItems:"center",gap:8},
  avatar:{width:30,height:30,borderRadius:"50%",background:"#E1F5EE",color:"#0F6E56",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:600},
  mobileOverlay:{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200},
  mobileMenu:{position:"absolute",top:0,right:0,width:280,height:"100vh",background:"#fff",padding:"20px",display:"flex",flexDirection:"column",gap:4,overflowY:"auto"},
  mobileUser:{display:"flex",alignItems:"center",gap:12,padding:"12px 0 16px",borderBottom:"0.5px solid #f0f0f0",marginBottom:8},
  mobileAvatar:{width:44,height:44,borderRadius:"50%",background:"#E1F5EE",color:"#0F6E56",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:600,flexShrink:0},
  mobileUserName:{fontSize:15,fontWeight:600,color:"#111"},
  mobileUserEmail:{fontSize:12,color:"#888",marginTop:2},
  mobileLink:{display:"block",padding:"12px 14px",borderRadius:10,fontSize:15,color:"#333",textDecoration:"none"},
  mobileLinkActive:{background:"#f0faf6",color:"#1D9E75",fontWeight:500},
  mobileBtnPublish:{display:"block",textAlign:"center",background:"#1D9E75",color:"#fff",borderRadius:10,padding:"13px",fontSize:15,fontWeight:600,textDecoration:"none",marginTop:12},
  mobileBtnLogout:{background:"#FEE",color:"#c0392b",border:"none",borderRadius:10,padding:"13px",fontSize:15,cursor:"pointer",marginTop:8,width:"100%"},
};
